import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue";
const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", null, "运单信息", -1);
const _hoisted_2 = {
  class: "state-city_container"
};
const _hoisted_3 = {
  class: "state-city_container"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_date_picker = _resolveComponent("el-date-picker");
  const _component_el_form = _resolveComponent("el-form");
  return _openBlock(), _createElementBlock("section", null, [_hoisted_1, _createVNode(_component_el_form, {
    ref: "form",
    "label-width": "auto",
    model: $data.waybillForm,
    class: "waybill-form",
    rules: $data.waybillRules
  }, {
    default: _withCtx(() => [_createVNode(_component_el_row, null, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        span: 8
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "运单号",
          prop: "waybill_no"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: $data.waybillForm.waybill_no,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.waybillForm.waybill_no = $event),
            disabled: ""
          }, null, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 8
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "订单号",
          prop: "order_no"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: $data.waybillForm.order_no,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.waybillForm.order_no = $event),
            clearable: "",
            filterable: "",
            remote: "",
            "reserve-keyword": "",
            loading: $data.orderLoading,
            "remote-method": str => $options.remoteMethod(str, 'order_id'),
            onChange: _cache[2] || (_cache[2] = val => $options.changeId(val, 'order_id'))
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.orderOption, option => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: option.id,
                label: option.order_no,
                value: option.id
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue", "loading", "remote-method"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 8
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "SKU",
          prop: "sku"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: $data.waybillForm.sku,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.waybillForm.sku = $event),
            clearable: "",
            filterable: "",
            remote: "",
            "reserve-keyword": "",
            loading: $data.skuLoading,
            "remote-method": str => $options.remoteMethod(str, 'sku_id'),
            onChange: _cache[4] || (_cache[4] = val => $options.changeId(val, 'sku_id'))
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.skuOption, option => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: option.id,
                label: option.name,
                value: option.id
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue", "loading", "remote-method"])]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    }), _createVNode(_component_el_row, null, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        span: 8
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "仓库",
          prop: "warehouse_id"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: $data.waybillForm.warehouse_id,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $data.waybillForm.warehouse_id = $event),
            filterable: "",
            clearable: ""
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.warehouse, item => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: item.id,
                label: item.name,
                value: item.id
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 8
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "发货时间",
          prop: "shipping_time"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_date_picker, {
            modelValue: $data.waybillForm.shipping_time,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $data.waybillForm.shipping_time = $event),
            clearable: "",
            type: "datetime"
          }, null, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      }), $data.addressVisible ? (_openBlock(), _createBlock(_component_el_col, {
        key: 0,
        span: 8
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "邮编",
          prop: "postcode"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: $data.waybillForm.postcode,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => $data.waybillForm.postcode = $event),
            clearable: "",
            onChange: $options.checkPostcodeValid
          }, null, 8, ["modelValue", "onChange"])]),
          _: 1
        })]),
        _: 1
      })) : _createCommentVNode("", true)]),
      _: 1
    }), $data.addressVisible ? (_openBlock(), _createBlock(_component_el_row, {
      key: 0
    }, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        span: 8
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "客户国家",
          prop: "country_id"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: $data.waybillForm.country_id,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => $data.waybillForm.country_id = $event),
            filterable: "",
            clearable: "",
            placeholder: "",
            onClear: $options.clearCountry,
            onChange: $options.changeCountry
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.country, item => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: item.id,
                label: item.name_cn ? `${item.origin}(${item.name_cn})` : item.origin,
                value: item.id
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue", "onClear", "onChange"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 8
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "客户州",
          prop: "state"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_select, {
            modelValue: $data.waybillForm.state_id,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => $data.waybillForm.state_id = $event),
            filterable: "",
            clearable: "",
            placeholder: "",
            onClear: $options.clearState,
            onChange: _cache[10] || (_cache[10] = $event => $options.getCity($data.waybillForm.country_id, $data.waybillForm.state_id))
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.state, item => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: item.id,
                label: item.name_cn ? `${item.origin}(${item.name_cn})` : item.origin,
                value: item.id,
                disabled: item.disabled
              }, null, 8, ["label", "value", "disabled"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue", "onClear"]), _createVNode(_component_el_input, {
            modelValue: $data.waybillForm.origin_state,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => $data.waybillForm.origin_state = $event),
            disabled: ""
          }, null, 8, ["modelValue"])])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 8
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "客户城市",
          prop: "city"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_select, {
            modelValue: $data.waybillForm.city_id,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => $data.waybillForm.city_id = $event),
            filterable: "",
            clearable: "",
            placeholder: ""
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.city, item => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: item.id,
                label: item.name_cn ? `${item.origin}(${item.name_cn})` : item.origin,
                value: item.id,
                disabled: item.disabled
              }, null, 8, ["label", "value", "disabled"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"]), _createVNode(_component_el_input, {
            modelValue: $data.waybillForm.origin_city,
            "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => $data.waybillForm.origin_city = $event),
            disabled: ""
          }, null, 8, ["modelValue"])])]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    })) : _createCommentVNode("", true), $data.addressVisible ? (_openBlock(), _createBlock(_component_el_row, {
      key: 1
    }, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        span: 8
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "客户地址",
          prop: "address"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: $data.waybillForm.address,
            "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => $data.waybillForm.address = $event),
            clearable: ""
          }, null, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 8
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "客户姓名",
          prop: "name"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: $data.waybillForm.name,
            "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => $data.waybillForm.name = $event),
            clearable: ""
          }, null, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 8
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "客户电话",
          prop: "phone"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: $data.waybillForm.phone,
            "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => $data.waybillForm.phone = $event),
            clearable: ""
          }, null, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    })) : _createCommentVNode("", true), $data.addressVisible ? (_openBlock(), _createBlock(_component_el_form_item, {
      key: 2,
      label: "客户邮箱",
      prop: "email"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: $data.waybillForm.email,
        "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => $data.waybillForm.email = $event),
        clearable: ""
      }, null, 8, ["modelValue"])]),
      _: 1
    })) : _createCommentVNode("", true), _createVNode(_component_el_form_item, {
      label: "备注信息",
      prop: "remark"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: $data.waybillForm.remark,
        "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => $data.waybillForm.remark = $event),
        type: "textarea",
        rows: 6,
        clearable: ""
      }, null, 8, ["modelValue"])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      class: "btn-position"
    }, {
      default: _withCtx(() => [_renderSlot(_ctx.$slots, "default")]),
      _: 3
    })]),
    _: 3
  }, 8, ["model", "rules"])]);
}